const translation = {
  title: '市场',
  filters: {
    all: '全部',
  },
  server: {
    available: '可用',
    notFound: '没有找到符合条件的服务器',
  },
  resourceSelector: {
    title: '资源筛选',
    billingMode: '计费模式',
  }
}

export default translation